import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../urunDiv.css';
import kasarliTost from '../../assets/menu/yemekler/tostlar/kasarli-tost.jpeg';
import kasarliSucukluTost from '../../assets/menu/yemekler/tostlar/kasarli-sucuklu-tost.jpeg';

const Tostlar = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);
  const navigate = useNavigate(); 

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const tostKategorileri = {
    'Tostlar': [
      {
        id: 1,
        name: 'Kaşarlı Tost',
        price: '₺379,90',
        image: kasarliTost
      },
      {
        id: 2,
        name: 'Kaşarlı Sucuklu Tost',
        price: '₺399,90',
        image: kasarliSucukluTost
      }
    ]
  };

  const handleTostClick = (tost) => {
    if (tost.name === 'Kaşarlı Tost') {
      navigate('/tostlar/kasarli-tost');
    } else if (tost.name === 'Kaşarlı Sucuklu Tost') {
      navigate('/tostlar/kasarli-sucuklu-tost');
    }
  };

  return (
    isPhone ? (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Tostlar</h2>
        </div>
        
        {Object.entries(tostKategorileri).map(([kategori, tostlar]) => (
          <div key={kategori}>
            <div className="container" style={{marginTop: '20px'}}>
              <h2 style={{marginLeft: 'auto', fontWeight: '700', marginTop: '0px' }}>{kategori}</h2>
            </div>
            <hr style={{color: '#D8D8D8'}} />
            <div className="urun-grid">
              {tostlar.map((tost) => (
                <div 
                  key={tost.id} 
                  className="urun-kart"
                  onClick={() => handleTostClick(tost)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="urun-bilgi">
                    <h3 className="urun-ad">{tost.name}</h3>
                    <div className="urun-fiyat">{tost.price}</div>
                  </div>
                  <div className="urun-resim">
                    <img src={tost.image} alt={tost.name} style={{
                      width: '80px',
                      height: '80px',
                      objectFit: 'cover',
                      borderRadius: '100px',
                    }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Tostlar</h2>
        </div>
        
        {Object.entries(tostKategorileri).map(([kategori, tostlar]) => (
          <div style={{marginBottom: '80px'}} key={kategori}>
            <div className="container" style={{marginTop: '20px'}}>
              <h2 style={{marginLeft: 'auto', fontWeight: '700', marginTop: '0px' }}>{kategori}</h2>
            </div>
            <hr style={{color: '#D8D8D8'}} />
            <div className="urun-grid-computer">
              {tostlar.map((tost) => (
                <div 
                  key={tost.id} 
                  className="urun-kart-computer"
                  onClick={() => handleTostClick(tost)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="urun-bilgi">
                    <h3 className="urun-ad-computer">{tost.name}</h3>
                    <div className="urun-fiyat-computer">{tost.price}</div>
                  </div>
                  <div className="urun-resim">
                    <img src={tost.image} alt={tost.name} style={{
                      width: '100px',
                      height: '100px',
                      objectFit: 'cover',
                      borderRadius: '100px',
                    }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    )
  );
};

export default Tostlar;
